import { DATA_CENTER_ACTIONS, FILE_HISTORY_ACTIONS, DATA_CENTER_FILE_REQUEST, DATA_CENTER_FILE_HEADERS, FILE_RECORDS_ACTIONS } from "./DataCenterActionTypes";

export const dataCenterCreateAction = (payload) => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_CREATE,
    payload,
});

export const dataCenterCreateSuccessAction = (data) => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_SUCCESS,
    data,
});

export const dataCenterCreateErrorAction = () => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_ERROR,
});

export const dataCenterListAction = () => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST,
});

export const dataCenterListSuccessAction = (data) => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST_SUCCESS,
    data,
});

export const dataCenterListErrorAction = () => ({
    type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST_ERROR,
});

export const fetchFileHistoryRequest = (dataCenterId) => ({
    type: FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_REQUEST,
    payload: {
        data: dataCenterId
    }
});

export const fetchFileHistorySuccess = (data, totalRows) => ({
    type: FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_SUCCESS,
    payload: { data, totalRows },
});

export const fetchFileHistoryError = () => ({
    type: FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_ERROR,
});

export const fileUploadRequest = (data) => ({
    type: DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_REQUEST,
    payload: data,
});

export const fileUploadSuccess = (response) => ({
    type: DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_SUCCESS,
    payload: response,
});

export const fileUploadError = (error) => ({
    type: DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_ERROR,
    payload: error,
});

export const getFileHeadersRequest = (data) => ({
    type: DATA_CENTER_FILE_HEADERS.FILE_HEADERS_REQUEST,
    payload: data,
});

export const getFileHeadersSuccess = (headers) => ({
    type: DATA_CENTER_FILE_HEADERS.FILE_HEADERS_SUCCESS,
    payload: headers,
});

export const getFileHeadersError = (error) => ({
    type: DATA_CENTER_FILE_HEADERS.FILE_HEADERS_ERROR,
    payload: error,
});

export const addColumn = () => ({
    type: DATA_CENTER_FILE_HEADERS.ADD_COLUMN,
});

export const updateColumn = (fieldName, headerValue) => ({
    type: DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN,
    payload: { headerValue, fieldName }
});

export const removeColumn = (id) => ({
    type: DATA_CENTER_FILE_HEADERS.REMOVE_COLUMN,
    payload: id,
});

export const fetchFileRecordsRequest = (data) => ({
    type: FILE_RECORDS_ACTIONS.FILE_RECORDS_REQUEST,
    payload: { ...data }
});

export const fetchFileRecordsSuccess = (data) => ({
    type: FILE_RECORDS_ACTIONS.FILE_RECORDS_SUCCESS,
    payload: { data },
});

export const fetchFileRecordsError = (error) => ({
    type: FILE_RECORDS_ACTIONS.FILE_RECORDS_ERROR,
    payload: error,
});

export const updateDataCenterId = (id) => ({
    type: FILE_RECORDS_ACTIONS.UPDATE_DATA_CENTER_ID,
    payload: id,
});

export const updateColumnVisibilityRequest = (columns) => ({
    type: DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_REQUEST,
    payload: columns,
});

export const updateColumnVisibilitySuccess = (columns) => ({
    type: DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_SUCCESS,
    payload: columns,
});

export const updateColumnVisibilityError = (error) => ({
    type: DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_ERROR,
    payload: error,
});

